var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCautionInverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8539 25.2586L15.4725 0.556199C15.3681 0.377233 15.1757 0.267578 14.9667 0.267578C14.7619 0.267578 14.5705 0.377233 14.4691 0.556199L0.0815135 25.2586C-0.0240037 25.4396 -0.0281417 25.661 0.0753066 25.8431C0.181858 26.0231 0.372203 26.1348 0.580134 26.1348H29.3532C29.5612 26.1348 29.7557 26.0231 29.8581 25.8431C29.9067 25.7521 29.9346 25.6507 29.9346 25.5524C29.9356 25.45 29.9077 25.3486 29.8539 25.2586ZM16.9332 9.03482L16.4553 18.8552H13.9839L13.507 9.03482H16.9332ZM15.1746 23.8827H15.2181C16.3901 23.8827 17.1505 23.0376 17.1494 21.91C17.1277 20.739 16.3674 19.9372 15.2181 19.9372C14.0688 19.9372 13.2681 20.74 13.2681 21.91C13.2681 23.0376 14.0481 23.8827 15.1746 23.8827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionInverse);
export default __webpack_public_path__ + "static/media/caution-inverse.129959f3c23675802fb2077ca94fe701.svg";
export { ForwardRef as ReactComponent };